import router from '../../router'
import {allowOnlyAuthorized} from '../../router/routeGuards'

import Favorites from './Favorites.vue'
import AppHeaderWithMenu from '../../components/layout/AppHeaderWithMenu'
// import AppSidebar from '../../components/layout/AppSidebar'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/favorites/:raceId',
      name: 'favorites',
      components: {
        default: Favorites,
        header: AppHeaderWithMenu,
      },
      beforeEnter: allowOnlyAuthorized()
    }
  ])
}
